import React from 'react'
import { sortable } from 'react-sortable'

class Item extends React.Component {
  render() {
    return (
      <tr {...this.props}>
        <td>{this.props.item.category_name}</td>
        <td>{this.props.item.link}</td>
        <td>{this.props.item.resource_attachment}</td>
        <a href={`/admin/school_resources/${this.props.item.id}`}>Show</a> |
        <a href={`/admin/school_resources/${this.props.item.id}/edit`}>Edit</a>
        <a href={`/admin/school_resources/${this.props.item.id}`} data-method="delete">Delete</a>
      </tr>
    )
  }
}

export default sortable(Item)
